<template>
    <div>
        <v-dialog v-model="cancelDialog" persistent>
            <v-card>
                <v-toolbar card color="primary" class="white--text" >
                    <v-toolbar-title><h4>Cancelación de Póliza</h4></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6>
                                <v-select
                                        :items="razones"
                                        v-model="editedItem.razon_cancelacion"
                                        label="Razón de cancelación"
                                        item-text="nombre"
                                        item-value="id"
                                        hide-details
                                        return-object
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-menu
                                        ref="dialogFechaCancelacion"
                                        :close-on-content-click="false"
                                        v-model="dialogFechaCancelacion"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            :value="computedFechaCancelacion"
                                            label="Fecha Cancelación"
                                            persistent-hint
                                            prepend-icon="event"
                                            @blur="fecha_cancelacion_string = parseDate($event.target.value)"
                                    ></v-text-field>
                                    <v-date-picker v-model="fecha_cancelacion_string" no-title @input="dialogFechaCancelacion = false" locale="es-ar"></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"   @click.native="doCancelar">Guardar</v-btn>
                    <v-btn color="secondary" @click.native="cancelDialog=false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="crudDialog" fullscreen persistent>
            <v-card>
                <v-toolbar card color="primary" class="white--text" >
                    <v-toolbar-title><h4>{{ formTitle }}</h4></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.nro_pedido"
                                        label="Nro Propuesta"
                                        placeholder="Autogenerado"
                                        readonly
                                        disabled
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-autocomplete v-model="editedItem.cliente"
                                        :items="clientes"
                                        :error-messages="clienteErrors"
                                        cache-items
                                        item-text="nombre"
                                        item-value="id"
                                        label="Cliente"
                                        clearable
                                        hide-details
                                        return-object
                                        @change="$v.editedItem.cliente.$touch()"
                                        @blur="$v.editedItem.cliente.$touch()"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-autocomplete
                                        v-model="editedItem.aseguradora"
                                        :items="aseguradoras"
                                        :error-messages="aseguradoraErrors"
                                        cache-items
                                        item-text="nombre"
                                        item-value="id"
                                        label="Aseguradora"
                                        clearable
                                        hide-details
                                        return-object
                                        @change="$v.editedItem.aseguradora.$touch()"
                                        @blur="$v.editedItem.aseguradora.$touch()"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field
                                        v-model="editedItem.nro_poliza"
                                        label="Nro Póliza"
                                        :error-messages="nroPolizaErrors"
                                        @input="$v.editedItem.nro_poliza.$touch()"
                                        @blur="$v.editedItem.nro_poliza.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-autocomplete v-model="editedItem.tipo_poliza"
                                                :items="tipos"
                                                :error-messages="tipoPolizaErrors"
                                                cache-items
                                                item-text="nombre"
                                                item-value="id"
                                                label="Tipo Póliza"
                                                clearable
                                                hide-details
                                                return-object
                                                @change="$v.editedItem.tipo_poliza.$touch()"
                                                @blur="$v.editedItem.tipo_poliza.$touch()"
                                ></v-autocomplete>
                            </v-flex>


                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Vida Individual'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Documento"
                                        :error-messages="datoPoliza1Errors"
                                        mask="##########"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Vida Individual'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Apellido y nombre"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Vida Individual'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza3Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual Integro'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Apellido y nombre"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual Integro'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza2Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual 24 Horas'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Apellido y nombre"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual 24 Horas'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza2Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual Deportes'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Apellido y nombre"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual Deportes'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza2Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Salud - Plan Individual'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Apellido y nombre"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Salud - Plan Individual'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza2Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual Asistencial'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Apellido y nombre"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual Asistencial'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza2Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Rc Servicios Profesionales (Individual)'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza1Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Rc Servicios Médicos (Clínicas)'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza1Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Mascotas'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza1Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Seguro Técnico'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Descripción"
                                        :error-messages="datoPoliza1Errors"

                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Seguro Técnico'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        mask="##########"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>



                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Caución'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Descripción"
                                        :error-messages="datoPoliza1Errors"

                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Caución'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        mask="##########"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>



                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Responsabilidad Civil'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Descripción"
                                        :error-messages="datoPoliza1Errors"

                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Responsabilidad Civil'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        mask="##########"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual en Ocasión del Trabajo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Apellido y nombre"
                                        :error-messages="datoPoliza1Errors"

                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Ap Individual en Ocasión del Trabajo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Monto Asegurado"
                                        mask="##########"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Integral del Comercio'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Domicilio Asegurado"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Integral del Comercio'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Localidad"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Integral del Comercio'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Valuación"
                                        :error-messages="datoPoliza3Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Incendio'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Domicilio Asegurado"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Incendio'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Localidad"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Incendio'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Valuación"
                                        :error-messages="datoPoliza3Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Robo de Valores'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Domicilio Asegurado"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Robo de Valores'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Localidad"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Robo de Valores'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Valuación"
                                        :error-messages="datoPoliza3Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Todo Riesgo Operativo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Ubicacion del Riesgo"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Todo Riesgo Operativo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Localidad"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Todo Riesgo Operativo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Monto Asegurado"
                                        :error-messages="datoPoliza3Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>




                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Integral del Hogar'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Domicilio Asegurado"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Integral del Hogar'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Localidad"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Integral del Hogar'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Valuación"
                                        :error-messages="datoPoliza3Errors"
                                        mask="#########"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>


                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && (editedItem.tipo_poliza.nombre==='Automotor' || editedItem.tipo_poliza.nombre==='Automotor (Flota)')">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Dominio"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && (editedItem.tipo_poliza.nombre==='Automotor' || editedItem.tipo_poliza.nombre==='Automotor (Flota)')">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Marca"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && (editedItem.tipo_poliza.nombre==='Automotor' || editedItem.tipo_poliza.nombre==='Automotor (Flota)')">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Modelo"
                                        :error-messages="datoPoliza3Errors"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && (editedItem.tipo_poliza.nombre==='Automotor' || editedItem.tipo_poliza.nombre==='Automotor (Flota)')">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_4"
                                        label="Año Fabricación"
                                        :error-messages="datoPoliza4Errors"
                                        mask="####"
                                        @input="$v.editedItem.dato_poliza_4.$touch()"
                                        @blur="$v.editedItem.dato_poliza_4.$touch()"
                                ></v-text-field>
                            </v-flex>



                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Motovehículo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Dominio"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Motovehículo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Marca"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Motovehículo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Modelo"
                                        :error-messages="datoPoliza3Errors"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Motovehículo'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_4"
                                        label="Año Fabricación"
                                        :error-messages="datoPoliza4Errors"
                                        mask="####"
                                        @input="$v.editedItem.dato_poliza_4.$touch()"
                                        @blur="$v.editedItem.dato_poliza_4.$touch()"
                                ></v-text-field>
                            </v-flex>



                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Casco Embarcaciones'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_1"
                                        label="Dominio"
                                        :error-messages="datoPoliza1Errors"
                                        @input="$v.editedItem.dato_poliza_1.$touch()"
                                        @blur="$v.editedItem.dato_poliza_1.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Casco Embarcaciones'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_2"
                                        label="Marca"
                                        :error-messages="datoPoliza2Errors"
                                        @input="$v.editedItem.dato_poliza_2.$touch()"
                                        @blur="$v.editedItem.dato_poliza_2.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Casco Embarcaciones'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_3"
                                        label="Modelo"
                                        :error-messages="datoPoliza3Errors"
                                        @input="$v.editedItem.dato_poliza_3.$touch()"
                                        @blur="$v.editedItem.dato_poliza_3.$touch()"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 v-if="editedItem.tipo_poliza && editedItem.tipo_poliza.nombre==='Casco Embarcaciones'">
                                <v-text-field
                                        v-model="editedItem.dato_poliza_4"
                                        label="Año Fabricación"
                                        :error-messages="datoPoliza4Errors"
                                        mask="####"
                                        @input="$v.editedItem.dato_poliza_4.$touch()"
                                        @blur="$v.editedItem.dato_poliza_4.$touch()"
                                ></v-text-field>
                            </v-flex>




                            <v-flex xs12 sm6>
                                <v-select
                                        :items="forma_pago"
                                        v-model="editedItem.forma_pago"
                                        label="Forma de Pago"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-menu
                                        ref="dialogInicio"
                                        :close-on-content-click="false"
                                        v-model="dialogInicio"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            :value="computedInicioVigencia"
                                            label="Inicio Vigencia"
                                            persistent-hint
                                            prepend-icon="event"
                                            @blur="editedItem.inicio_vigencia_string = parseDate($event.target.value)"
                                    ></v-text-field>
                                    <v-date-picker v-model="editedItem.inicio_vigencia_string" no-title @input="dialogInicio = false" locale="es-ar"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-menu
                                        ref="dialogFin"
                                        :close-on-content-click="false"
                                        v-model="dialogFin"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            :value="computedFinVigencia"
                                            label="Fin Vigencia"
                                            persistent-hint
                                            prepend-icon="event"
                                            @blur="editedItem.fin_vigencia_string = parseDate($event.target.value)"
                                    ></v-text-field>
                                    <v-date-picker v-model="editedItem.fin_vigencia_string" no-title @input="dialogFin = false" locale="es-ar"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                        v-model="editedItem.observacion"
                                        auto-grow
                                        box
                                        color="deep-purple"
                                        label="Observaciones"
                                        rows="1"
                                ></v-textarea>
                            </v-flex>

                        </v-layout>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="teal" v-if="editedItem.estado ==='aprobada' && editedItem.renovada === false " @click.native="renovarItem">Renovar</v-btn>
                    <v-btn color="primary" :disabled="$v.$invalid" @click.native="save">Guardar</v-btn>
                    <v-btn color="secondary" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-toolbar extended :extensionHeight="extensionHeight">
                <v-btn
                    fab
                    small
                    color="success"
                    bottom
                    left
                    absolute
                    @click="addItem"
                    >
                    <v-icon>add</v-icon>
                </v-btn>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex md3 sm6 xs12>
                            <v-autocomplete
                                    :items="tipos"
                                    v-model="searchFilter.tipo_poliza"
                                    cache-items
                                    label="Tipo Póliza"
                                    clearable
                                    @change="onSearchfilterChanged"
                                    dense
                                    single-line
                                    class="mr-1"
                                    hide-details
                                    item-text="nombre"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-select
                                    :items="estados"
                                    v-model="searchFilter.estado"
                                    label="Estado"
                                    clearable
                                    @change="onSearchfilterChanged"
                                    dense
                                    single-line
                                    class="mr-1"
                                    hide-details
                            ></v-select>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-autocomplete
                                    :items="asesores"
                                    v-model="searchFilter.asesor"
                                    cache-items
                                    label="Asesor"
                                    clearable
                                    @change="onSearchfilterChanged"
                                    dense
                                    single-line
                                    class="mr-1"
                                    hide-details
                                    item-text="nombre"
                                    item-value="id"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-autocomplete
                                    v-model="searchFilter.aseguradora"
                                    :items="aseguradoras"
                                    cache-items
                                    item-text="nombre"
                                    item-value="id"
                                    label="Aseguradora"
                                    clearable
                                    single-line
                                    hide-details
                                    @change="onSearchfilterChanged"
                                    class="mr-1"
                                    dense
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-menu
                                    ref="dialogStartVigencia"
                                    :close-on-content-click="false"
                                    v-model="dialogStartVigencia"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <v-text-field
                                        slot="activator"
                                        :value="computedFechaStartVigencia"
                                        label="Desde Fecha Inicio Vigencia"
                                        persistent-hint
                                        clearable
                                        prepend-icon="event"
                                        @blur="searchFilter.start_vi = parseDateEmpty($event.target.value)"
                                ></v-text-field>
                                <v-date-picker v-model="searchFilter.start_vi" no-title @input="dialogStartVigencia = false" locale="es-ar"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-menu
                                    ref="dialogEndVigencia"
                                    :close-on-content-click="false"
                                    v-model="dialogEndVigencia"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <v-text-field
                                        slot="activator"
                                        :value="computedFechaEndVigencia"
                                        label="Hasta Fecha Hasta Vigencia"
                                        persistent-hint
                                        clearable
                                        prepend-icon="event"
                                        @blur="searchFilter.end_vi = parseDateEmpty($event.target.value)"
                                ></v-text-field>
                                <v-date-picker v-model="searchFilter.end_vi" no-title @input="dialogEndVigencia = false" locale="es-ar"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex md3 sm6 xs12>
                            <v-menu
                                    ref="dialogStartFin"
                                    :close-on-content-click="false"
                                    v-model="dialogStartFin"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <v-text-field
                                        slot="activator"
                                        :value="computedFechaStartFin"
                                        label="Desde Fecha Fin"
                                        persistent-hint
                                        clearable
                                        prepend-icon="event"
                                        @blur="searchFilter.start_fin = parseDateEmpty($event.target.value)"
                                ></v-text-field>
                                <v-date-picker v-model="searchFilter.start_fin" no-title @input="dialogStartFin = false" locale="es-ar"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-menu
                                    ref="dialogEndFin"
                                    :close-on-content-click="false"
                                    v-model="dialogEndFin"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <v-text-field
                                        slot="activator"
                                        :value="computedFechaEndFin"
                                        label="Hasta Fecha Fin"
                                        persistent-hint
                                        clearable
                                        prepend-icon="event"
                                        @blur="searchFilter.end_fin = parseDateEmpty($event.target.value)"
                                ></v-text-field>
                                <v-date-picker v-model="searchFilter.end_fin" no-title @input="dialogEndFin = false" locale="es-ar"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex md3 sm6 xs12>
                            <v-checkbox
                                    v-model="searchFilter.vigentes"
                                    label="Solo Vigentes"
                                    @change="onSearchfilterChanged"
                            ></v-checkbox>
                        </v-flex>
                        <v-flex md5 sm6 xs12>
                            <v-text-field
                                    v-model="searchFilter.name"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    @change="onSearchfilterChanged"
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                                <v-layout>
                                    <v-flex xs4>
                                        <v-tooltip bottom>
                                            <v-btn color="primary"   @click.native="onSearchfilterChanged()" slot="activator">
                                                <v-icon>search</v-icon>
                                            </v-btn>
                                            <span>Buscar</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-tooltip bottom>
                                            <v-btn color="accent" @click="doDownloadXLS()" slot="activator">
                                                <v-icon>attach_file</v-icon>
                                            </v-btn>
                                            <span>Bajar Excel Sin Filtro</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-tooltip bottom>
                                            <v-btn @click="doDownloadXLSFiltrado()" slot="activator">
                                                <v-icon>cloud_download</v-icon>
                                            </v-btn>
                                            <span>Bajar Excel Filtrado</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                        </v-flex>

                    </v-layout>
                </v-container>
            </v-toolbar>
            <v-card-text class="pa-0">
                <template>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :total-items="totalItems"
                            :pagination.sync="pagination"
                            :loading="loading"
                            :hide-actions="loading"
                            :rows-per-page-items="itemsPerPage"
                            class="elevation-0"
                            dense
                    >
                        <template slot="items" slot-scope="props">
                            <td style="padding:0 5px" class="caption">
                                <strong>Póliza:</strong> {{ props.item.nro_poliza }}<br/>
                                <strong>Propuesta:</strong> {{ props.item.nro_pedido }}
                            </td>
                            <td style="padding:0 5px" class="caption">{{ props.item.cliente.nombre }} <br/> <strong>Datos :</strong> {{props.item.dato_poliza_1}} / {{props.item.dato_poliza_2}} / {{props.item.dato_poliza_3}}</td>
                            <td style="padding:0 5px" class="caption">{{ props.item.asesor.nombre }}</td>
                            <td style="padding:0 5px" class="caption">{{ props.item.aseguradora.nombre }}</td>
                            <td style="padding:0 5px" class="caption">
                                {{ props.item.estado }}
                                <span v-if="props.item.estado == 'cancelada'" class="caption">
                                    <strong>({{ props.item.razon_cancelacion.nombre }})</strong><br/>
                                    <strong>Fecha:</strong> {{ props.item.fecha_cancelacion.format('DD-MM-YYYY') }}
                                </span>
                                <span v-else class="caption">
                                    <br/>
                                    <strong>Inicio:</strong> {{ props.item.inicio_vigencia.format('DD-MM-YYYY') }}<br/>
                                    <strong>Fin:</strong> {{ props.item.fin_vigencia.format('DD-MM-YYYY') }}
                                </span>
                            </td>
                            <td style="padding:0 5px" class="caption">{{ props.item.tipo_poliza.nombre }}</td>
                            <td style="padding:0 5px" class="text-xs-right caption min-btn">
                                <v-btn flat icon color="teal" @click="expandItem(props)">
                                    <v-icon>folder_open</v-icon>
                                </v-btn>
                                <v-btn flat icon color="teal" @click="editItem(props.item)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn flat v-if="user.roles.includes('ADMINISTRADOR')" icon color="pink" @click="deleteItem(props.item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </td>
                        </template>
                        <template slot="expand" slot-scope="props">
                            <v-card>
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12 sm12 v-if="editedItem.estado ==='pendiente'">
                                                <p> Recuerde que para Aprobar una Póliza se debe definir el Nro de Póliza y subir la póliza previamente</p>
                                            </v-flex>
                                            <v-flex xs12 sm6 v-if="editedItem.estado ==='pendiente'">
                                                <v-text-field
                                                        v-model="editedItem.nro_poliza"
                                                        label="Nro Póliza"
                                                        :error-messages="nroPolizaErrors"
                                                        @input="$v.editedItem.nro_poliza.$touch()"
                                                        @blur="$v.editedItem.nro_poliza.$touch()"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm12>
                                                <v-input
                                                >
                                                    <p v-if="uploading"> Subiendo: {{ editedItem.file_name }} - ( {{uploadPercent}} % ) </p>
                                                    <p v-else> Archivo de poliza: {{ editedItem.file_name }}</p>
                                                    <v-spacer/>
                                                    <v-btn
                                                            color="secondary"
                                                            class="white--text"
                                                            :disabled="uploading"
                                                            :loading="uploading"
                                                            raised
                                                            @click="$refs.file.click()"
                                                    >
                                                        Subir Póliza
                                                        <v-icon right dark>cloud_upload</v-icon>
                                                    </v-btn>
                                                    <input
                                                            type="file"
                                                            ref="file"
                                                            name="file"
                                                            accept="application/pdf"
                                                            @change="onFilePicked"
                                                    >
                                                    <v-progress-linear v-model="uploadPercent" color="teal"></v-progress-linear>
                                                </v-input>
                                            </v-flex>
                                            <v-flex xs12 sm12>
                                                <v-data-table
                                                        :headers="headersInside"
                                                        :items="uploads"
                                                        :loading="loading"
                                                        :hide-actions="true"
                                                        class="elevation-0"
                                                        dense
                                                >
                                                    <template slot="items" slot-scope="props">
                                                        <td style="padding:0 5px">{{ props.item.file_name }}</td>
                                                        <td style="padding:0 5px" class="text-xs-right">
                                                            <v-btn
                                                                    color="accent"
                                                                    @click="doDownloadUpload(editedItem, props.item.id)"
                                                            >
                                                                <v-icon>attach_file</v-icon>
                                                            </v-btn>
                                                            <v-btn @click="doDeleteUpload(editedItem, props.item.id)">
                                                                <v-icon>delete</v-icon>
                                                            </v-btn>
                                                        </td>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-container>
                                        <v-layout>
                                            <v-flex sm8 xs12 class="text-xs-left">
                                                <v-btn color="teal" @click.native="doGuardar" :disabled="$v.$invalid" v-if="editedItem.nro_poliza !== ''" >Guardar</v-btn>
                                                <v-btn :disabled="$v.$invalid" v-if="editedItem.estado ==='pendiente'  && editedItem.nro_poliza !== ''" color="success" @click.native="doAprobar">Aprobar</v-btn>
                                                <v-btn :disabled="$v.$invalid" v-if="editedItem.estado ==='pendiente'" color="error" @click.native="doDenegar">Denegar</v-btn>
                                                <v-btn v-if="editedItem.estado ==='aprobada'" color="error" @click.native="doCancelarPopup">Cancelar Póliza</v-btn>
                                            </v-flex>
                                            <v-flex sm4 xs12 class="text-xs-right">
                                                <v-btn color="secondary" @click.native="doCancel">Cerrar</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-actions>
                            </v-card>
                        </template>
                    </v-data-table>
                </template>
                <v-divider></v-divider>
            </v-card-text>
            <v-snackbar color="error" error v-if="error" :timeout="errorTimeout" :bottom="true"
                        v-model="error">
                {{ errorMessage }}
                <v-btn secondary flat @click.native="error = false">Close</v-btn>
            </v-snackbar>
            <v-snackbar color="success" v-if="success" :timeout="successTimeout" :bottom="true"
                        v-model="success">
                {{ successMessage }}
            </v-snackbar>
        </v-card>
    </div>

</template>

<script>
  import { required, maxLength } from 'vuelidate/lib/validators'
  import moment from 'moment'
  import qs from 'qs'
  import axios from '@/api/axios'
  import store from '@/store'

  const nroPolizaUnique = (value, parentVm) => {
    if (value === '') return true
    if (parentVm.aseguradora === null) return true
    if (parentVm.aseguradora === undefined) return true
    store.commit('setDisabledLoading', true)
    return axios.post('/polizas/exists', qs.stringify({ nro_poliza: value, aseguradora: parentVm.aseguradora.id, id: parentVm.id }))
        .then(res => {
          return !res.data
        }).finally(() => (store.dispatch('setDisabledLoading', false)))
  }

  export default {
    data () {
      return {
        uploading: false,
        uploadPercent: 0,
        error: false,
        errorMessage: '',
        errorTimeout: 6000,
        success: false,
        successMessage: '',
        successTimeout: 2000,
        searchFilter: {
          name: '',
          aseguradora: null,
          estado: null,
          start_vi: '',
          end_vi: '',
          start_fin: '',
          end_fin: '',
          vigentes: true
        },
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          rowsPerPage: 50,
          search: '',
          asesor: null,
          start_vi: '',
          end_vi: '',
          start_fin: '',
          end_fin: '',
          aseguradora: null,
          tipo_poliza: null,
          estado: null,
          vigentes: true
        },
        crudDialog: false,
        cancelDialog: false,
        dialogInicio: false,
        dialogFin: false,
        dialogFechaCancelacion: false,
        dialogStartVigencia: false,
        dialogEndVigencia: false,
        dialogStartFin: false,
        dialogEndFin: false,
        fecha_cancelacion_string: moment().format('YYYY-MM-DD'),
        editedProps: null,
        editedIndex: -1,
        editedItem: {
          id: '',
          nro_poliza: '',
          nro_pedido: '',
          cliente: null,
          cliente_id: null,
          asesor: null,
          asesor_id: null,
          aseguradora: null,
          aseguradora_id: null,
          tipo_poliza: null,
          tipo_poliza_id: null,
          razon_cancelacion_id: null,
          razon_cancelacion: null,
          fecha_cancelacion: null,
          estado: 'pendiente',
          forma_pago: 'DEBITO BANCARIO',
          identificador_riesgo: '',
          created: moment(),
          updated: moment(),
          inicio_vigencia_string: moment().format('YYYY-MM-DD'),
          inicio_vigencia_carga: moment().format('DD/MM/YYYY'),
          inicio_vigencia: moment(),
          fin_vigencia_string: moment().format('YYYY-MM-DD'),
          fin_vigencia: moment(),
          dato_poliza_1: '',
          dato_poliza_2: '',
          dato_poliza_3: '',
          dato_poliza_4: '',
          observacion: '',
          renovada: false,
          poliza_anterior_id: null
        },
        defaultItem: {
          id: '',
          nro_pedido: '',
          nro_poliza: '',
          cliente: null,
          cliente_id: null,
          asesor: null,
          asesor_id: null,
          aseguradora: null,
          aseguradora_id: null,
          tipo_poliza: null,
          tipo_poliza_id: null,
          estado: 'pendiente',
          razon_cancelacion_id: null,
          razon_cancelacion: null,
          fecha_cancelacion: null,
          forma_pago: 'DEBITO BANCARIO',
          identificador_riesgo: '',
          created: moment(),
          updated: moment(),
          inicio_vigencia_string: moment().format('YYYY-MM-DD'),
          inicio_vigencia_carga: moment().format('DD/MM/YYYY'),
          inicio_vigencia: moment(),
          fin_vigencia_string: moment().format('YYYY-MM-DD'),
          fin_vigencia: moment(),
          dato_poliza_1: '',
          dato_poliza_2: '',
          dato_poliza_3: '',
          dato_poliza_4: '',
          observacion: '',
          renovada: false,
          poliza_anterior_id: null
        },
        uploads: [],
        aseguradoras: [],
        clientes: [],
        tipos: [],
        razones: [],
        asesores: [],
        forma_pago: [
          'DEBITO BANCARIO',
          'DEBITO TARJ CREDITO',
          'CUPONERA',
          'AFIP'
        ],
        estados: [
          'pendiente',
          'aprobada',
          'cancelada',
          'denegada'
        ],
        modalInicio: false,
        modalFin: false,
        loading: false,
        headers: [
          {
            text: 'Número Ref.',
            align: 'left',
            sortable: true,
            value: 'nro_poliza'
          },
          {
            text: 'Cliente',
            align: 'left',
            sortable: true,
            value: 'cliente'
          },
          {
            text: 'Asesor',
            align: 'left',
            sortable: true,
            value: 'asesor'
          },
          {
            text: 'Aseguradora',
            align: 'left',
            sortable: true,
            value: 'aseguradora'
          },
          {
            text: 'Estado',
            align: 'left',
            sortable: true,
            value: 'estado'
          },
          {
            text: 'Tipo',
            align: 'left',
            sortable: true,
            value: 'tipo_poliza_id'
          },
          { text: 'Acciones', value: 'action', align: 'right', sortable: false }
        ],
        headersInside: [
          {
            text: 'Nombre Archivo',
            align: 'left',
            sortable: false,
            value: 'file_name'
          },
          { text: 'Acciones', value: 'action', align: 'right', sortable: false }
        ]
      }
    },
    computed: {
      user () {
        return store.getters['user/user']
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Póliza' : 'Editar Póliza'
      },
      itemsPerPage () {
        return store.getters['itemsPerPage']
      },
      extensionHeight () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 700
          case 'sm': return 400
          default: return 140
        }
      },
      computedInicioVigencia () {
        if (this.editedItem.inicio_vigencia_string !== '') {
          return moment(this.editedItem.inicio_vigencia_string).format('DD/MM/YYYY')
        }
        return ''
      },
      computedFinVigencia () {
        if (this.editedItem.fin_vigencia_string !== '') {
          return moment(this.editedItem.fin_vigencia_string).format('DD/MM/YYYY')
        }
        return ''
      },
      computedFechaCancelacion () {
        if (this.fecha_cancelacion_string !== '') {
          return moment(this.fecha_cancelacion_string).format('DD/MM/YYYY')
        }
        return ''
      },
      computedFechaStartVigencia () {
        if (this.searchFilter.start_vi !== '') {
          return moment(this.searchFilter.start_vi).format('DD/MM/YYYY')
        }
        return ''
      },
      computedFechaEndVigencia () {
        if (this.searchFilter.end_vi !== '') {
          return moment(this.searchFilter.end_vi).format('DD/MM/YYYY')
        }
        return ''
      },
      computedFechaStartFin () {
        if (this.searchFilter.start_fin !== '') {
          return moment(this.searchFilter.start_fin).format('DD/MM/YYYY')
        }
        return ''
      },
      computedFechaEndFin () {
        if (this.searchFilter.end_fin !== '') {
          return moment(this.searchFilter.end_fin).format('DD/MM/YYYY')
        }
        return ''
      },
      nroPolizaErrors () {
        let errors = []
        if (!this.$v.editedItem.nro_poliza.$dirty) return errors
        !this.$v.editedItem.nro_poliza.maxLength && errors.push('Máximo 20 caracteres')
        !this.$v.editedItem.nro_poliza.nroPolizaUnique && errors.push('El nro de póliza ya existe.')
        return errors
      },
      aseguradoraErrors () {
        let errors = []
        if (!this.$v.editedItem.aseguradora.$dirty) return errors
        !this.$v.editedItem.aseguradora.required && errors.push('Aseguradora requerida.')
        return errors
      },
      clienteErrors () {
        let errors = []
        if (!this.$v.editedItem.cliente.$dirty) return errors
        !this.$v.editedItem.cliente.required && errors.push('Cliente requerido.')
        return errors
      },
      tipoPolizaErrors () {
        let errors = []
        if (!this.$v.editedItem.tipo_poliza.$dirty) return errors
        !this.$v.editedItem.tipo_poliza.required && errors.push('Tipo requerido.')
        return errors
      },
      datoPoliza1Errors () {
        let errors = []
        if (!this.$v.editedItem.dato_poliza_1.$dirty) return errors
        if (this.editedItem.tipo_poliza && (this.editedItem.tipo_poliza.nombre === 'Automotor' || this.editedItem.tipo_poliza.nombre === 'Automotor (Flota)')) {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 10 caracteres')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Motovehículo') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 10 caracteres')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Casco Embarcaciones') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 10 caracteres')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Hogar') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Domicilio es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Comercio') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Domicilio es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Incendio') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Domicilio es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Robo de Valores') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Domicilio es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Todo Riesgo Operativo') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Domicilio es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual en Ocasión del Trabajo') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 100 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Nombre y apellido es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Vida Individual') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Documento es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Rc Servicios Profesionales (Individual)') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Rc Servicios Médicos (Clínicas)') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Mascotas') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Seguro Técnico') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 200 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('Descripción Requerida.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Caución') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 200 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('Descripción Requerida.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Responsabilidad Civil') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 200 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('Descripción Requerida.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Integro') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 100 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Nombre y apellido es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual 24 Horas') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 100 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Nombre y apellido es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Deportes') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 100 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Nombre y apellido es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Salud - Plan Individual') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 100 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Nombre y apellido es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Asistencial') {
          !this.$v.editedItem.dato_poliza_1.maxLength && errors.push('Máximo 100 caracteres')
          !this.$v.editedItem.dato_poliza_1.required && errors.push('El Nombre y apellido es requerido.')
        }
        return errors
      },
      datoPoliza2Errors () {
        let errors = []
        if (!this.$v.editedItem.dato_poliza_2.$dirty) return errors
        if (this.editedItem.tipo_poliza && (this.editedItem.tipo_poliza.nombre === 'Automotor' || this.editedItem.tipo_poliza.nombre === 'Automotor (Flota)')) {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 20 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Marca requerida.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Motovehículo') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 20 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Marca requerida.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Casco Embarcaciones') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 20 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Marca requerida.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Hogar') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Localidad es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Comercio') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Localidad es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Incendio') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Localidad es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Robo de Valores') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 40 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Localidad es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Todo Riesgo Operativo') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 20 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Localidad es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual en Ocasión del Trabajo') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Vida Individual') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 100 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('El Nombre y apellido es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Seguro Técnico') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Caución') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Responsabilidad Civil') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Integro') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual 24 Horas') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Deportes') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Salud - Plan Individual') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Asistencial') {
          !this.$v.editedItem.dato_poliza_2.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_2.required && errors.push('Monto es requerido.')
        }
        return errors
      },
      datoPoliza3Errors () {
        let errors = []
        if (!this.$v.editedItem.dato_poliza_3.$dirty) return errors
        if (this.editedItem.tipo_poliza && (this.editedItem.tipo_poliza.nombre === 'Automotor' || this.editedItem.tipo_poliza.nombre === 'Automotor (Flota)')) {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 20 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Modelo requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Motovehículo') {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 20 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Modelo requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Casco Embarcaciones') {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 20 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Modelo requerido.')
        }

        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Hogar') {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Valuacion es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Comercio') {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Valuacion es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Incendio') {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Valuacion es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Robo de Valores') {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Valuacion es requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Todo Riesgo Operativo') {
          !this.$v.editedItem.dato_poliza_3.maxLength && errors.push('Máximo 10 caracteres')
          !this.$v.editedItem.dato_poliza_3.required && errors.push('Monto es requerido.')
        }
        return errors
      },
      datoPoliza4Errors () {
        let errors = []
        if (!this.$v.editedItem.dato_poliza_4.$dirty) return errors
        if (this.editedItem.tipo_poliza && (this.editedItem.tipo_poliza.nombre === 'Automotor' || this.editedItem.tipo_poliza.nombre === 'Automotor (Flota)')) {
          !this.$v.editedItem.dato_poliza_4.maxLength && errors.push('Máximo 4 caracteres')
          !this.$v.editedItem.dato_poliza_4.required && errors.push('Año Fabricación requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Motovehículo') {
          !this.$v.editedItem.dato_poliza_4.maxLength && errors.push('Máximo 4 caracteres')
          !this.$v.editedItem.dato_poliza_4.required && errors.push('Año Fabricación requerido.')
        }
        if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Casco Embarcaciones') {
          !this.$v.editedItem.dato_poliza_4.maxLength && errors.push('Máximo 4 caracteres')
          !this.$v.editedItem.dato_poliza_4.required && errors.push('Año Fabricación requerido.')
        }
        return errors
      }
    },
    methods: {
      getDataFromApi () {
        this.loading = true
        const {sortBy, descending, page, rowsPerPage, search, aseguradora, estado, tipo_poliza, start_vi, end_vi, start_fin, end_fin, vigentes} = this.pagination
        this.axios.post('/polizas',
          qs.stringify(
            {
              page,
              rowsPerPage,
              sortBy,
              descending,
              aseguradora,
              tipo_poliza,
              search,
              estado,
              start_vi,
              end_vi,
              start_fin,
              end_fin,
              vigentes
            })).then(
          response => {
            this.items = response.data.data.map(function (item) {
              item.created = moment(item.created)
              item.updated = moment(item.updated)
              item.fecha_cancelacion = item.fecha_cancelacion !== null ? moment(item.fecha_cancelacion) : null
              item.inicio_vigencia = moment(item.inicio_vigencia)
              item.inicio_vigencia_string = moment(item.inicio_vigencia).format('YYYY-MM-DD')
              item.fin_vigencia_string = moment(item.fin_vigencia).format('YYYY-MM-DD')
              item.fin_vigencia = moment(item.fin_vigencia)
              return item
            })
            this.totalItems = response.data.total_entries
            this.loading = false
          }
        ).catch(
          err => {
            console.log(err)
            this.loading = false
            this.errorMessage = 'Error al cargar listado'
            this.error = true
          }
        )
      },
      addItem () {
        this.crudDialog = true
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
        this.editedIndex = -1
        this.$v.$reset()
      },
      deleteItem (item) {
        this.$root.$confirm('Borrar Póliza', `¿Está seguro de borrar la póliza ${item.nro_poliza} ?`, { color: 'error' }).then(
          (confirm) => {
            if (confirm === true) {
              this.axios.delete('/polizas/delete/' + item.id).then(
                response => {
                  this.successMessage = 'Poliza borrada exitosamente.'
                  this.success = true
                  this.getDataFromApi()
                  this.close()
                }
              ).catch(
                _ => {
                  this.errorMessage = 'Error al borrar la póliza'
                  this.error = true
                  this.close()
                }
              )
            }
          },
          (reject) => { console.log(reject) })
      },
      renovarItem () {
        this.$root.$confirm('Renovar Póliza', `¿Está seguro de renovar la póliza ${this.editedItem.nro_poliza} ?`, { color: 'teal' }).then(
          (confirm) => {
            if (confirm === true) {
              this.editedItem = JSON.parse(JSON.stringify(this.editedItem))
              this.editedItem.poliza_anterior_id = this.editedItem.id
              this.editedItem.id = ''
              this.editedItem.nro_poliza = ''
              this.editedItem.nro_pedido = ''
              this.editedIndex = -1
              this.editedItem.created = moment(this.editedItem.created)
              this.editedItem.updated = moment(this.editedItem.updated)
              this.editedItem.inicio_vigencia = moment(this.editedItem.fin_vigencia)
              this.editedItem.inicio_vigencia_string = moment(this.editedItem.inicio_vigencia).format('YYYY-MM-DD')
              this.editedItem.estado = 'pendiente'
              this.$v.$reset()
            }
          },
          (reject) => { console.log(reject) })
      },
      expandItem (props) {
        if (!props.expanded) {
          this.editedProps = props
          this.editedItem = JSON.parse(JSON.stringify(props.item))
          this.editedItem.created = moment(this.editedItem.created)
          this.editedItem.updated = moment(this.editedItem.updated)
          this.editedItem.inicio_vigencia = moment(this.editedItem.inicio_vigencia)
          this.editedItem.fin_vigencia = moment(this.editedItem.fin_vigencia)
          this.getPolizaUploads()
        }
        props.expanded = !props.expanded
      },
      editItem (item) {
        if (this.editedProps != null) {
          this.editedProps.expanded = false
        }
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = JSON.parse(JSON.stringify(item))
        this.editedItem.created = moment(this.editedItem.created)
        this.editedItem.updated = moment(this.editedItem.updated)
        this.editedItem.inicio_vigencia = moment(this.editedItem.inicio_vigencia).format('YYYY-MM-DD')
        this.editedItem.fin_vigencia = moment(this.editedItem.fin_vigencia).format('YYYY-MM-DD')
        this.crudDialog = true
      },
      doDownloadUpload (item, uploadId) {
        this.axios.get('/polizas/download/' + item.id + '/' + uploadId, { responseType: 'arraybuffer' }).then(
          response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'poliza' + item.id + '_' + uploadId + '.pdf')
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al bajar el archivo'
            this.error = true
          }
        )
      },
      doDeleteUpload (item, uploadId) {
        this.$root.$confirm('Borrar Archivo de la Póliza', `¿Está seguro de borrar la póliza ${item.nro_poliza} ?`, { color: 'error' }).then(
          (confirm) => {
            if (confirm === true) {
              this.axios.delete('/polizas/uploads/' + item.id + '/' + uploadId).then(
                response => {
                  this.successMessage = 'Archivo de póliza borrada exitosamente.'
                  this.success = true
                  this.getPolizaUploads()
                }
              ).catch(
                _ => {
                  this.errorMessage = 'Error al borrar el archivo de la póliza'
                  this.error = true
                }
              )
            }
          },
          (reject) => { console.log(reject) })
      },
      doDownloadXLSFiltrado () {
        let aseguradora = null
        // eslint-disable-next-line
        let tipo_poliza = null
        if (this.searchFilter.aseguradora) {
          aseguradora = this.searchFilter.aseguradora
        }

        if (this.searchFilter.tipo_poliza) {
          // eslint-disable-next-line
          tipo_poliza = this.searchFilter.tipo_poliza
        }
        const { vigentes, start_vi, end_vi, asesor, search, estado, start_fin, end_fin } = this.searchFilter
        this.axios.post('/polizas/export_filtrado/xls',
          qs.stringify(
            {
              aseguradora,
              tipo_poliza,
              search,
              estado,
              start_vi,
              end_vi,
              start_fin,
              end_fin,
              vigentes,
              asesor
            }), { responseType: 'arraybuffer' }).then(
          response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'polizas_filtrado.xlsx')
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
          }
        ).catch(
          err => {
            console.log(err)
            this.errorMessage = 'Error al bajar el archivo filtrado'
            this.error = true
          }
        )
      },
      doDownloadXLS () {
        this.axios.get('/polizas/export/xls', { responseType: 'arraybuffer' }).then(
          response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'polizas.xlsx')
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al bajar el archivo'
            this.error = true
          }
        )
      },
      close () {
        this.crudDialog = false
        setTimeout(() => {
          this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
          this.$v.$reset()
        }, 300)
      },
      save () {
        let url = ''
        if (this.editedIndex > -1) {
          url = '/polizas/update'
        } else {
          url = '/polizas/add'
        }
        this.editedItem.inicio_vigencia = moment(this.editedItem.inicio_vigencia_string)
        this.editedItem.fin_vigencia = moment(this.editedItem.fin_vigencia_string)
        this.axios.post(url, this.editedItem).then(
          response => {
            this.successMessage = 'Póliza guardada exitosamente.'
            this.success = true
            this.getDataFromApi()
            this.close()
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar póliza.'
            this.error = true
            this.close()
          }
        )
      },
      doCancelarPopup () {
        this.cancelDialog = true
      },
      doCancelar () {
        const url = '/polizas/update'
        if (this.editedItem.razon_cancelacion === null) {
          return
        }
        if (this.fecha_cancelacion_string === '') {
          return
        }
        this.editedItem.estado = 'cancelada'
        this.editedItem.fecha_cancelacion = moment(this.fecha_cancelacion_string)
        this.axios.post(url, this.editedItem).then(
          response => {
            this.successMessage = 'Póliza cancelada exitosamente.'
            this.success = true
            this.cancelDialog = false
            this.getDataFromApi()
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar póliza.'
            this.error = true
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        )
      },
      doAprobar () {
        const url = '/polizas/update'
        this.editedItem.estado = 'aprobada'
        this.axios.post(url, this.editedItem).then(
          response => {
            this.successMessage = 'Póliza aprobada exitosamente.'
            this.success = true
            this.getDataFromApi()
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar póliza.'
            this.error = true
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        )
      },
      doDenegar () {
        const url = '/polizas/update'
        this.editedItem.estado = 'denegada'
        this.axios.post(url, this.editedItem).then(
          response => {
            this.successMessage = 'Póliza aprobada exitosamente.'
            this.success = true
            this.getDataFromApi()
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar póliza.'
            this.error = true
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        )
      },
      doGuardar () {
        const url = '/polizas/update'
        this.axios.post(url, this.editedItem).then(
          response => {
            this.successMessage = 'Póliza guardada exitosamente.'
            this.success = true
            this.getDataFromApi()
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        ).catch(
          _ => {
            this.errorMessage = 'Error al guardar póliza.'
            this.error = true
            if (this.editedProps != null) {
              this.editedProps.expanded = false
            }
          }
        )
      },
      doCancel () {
        if (this.editedProps != null) {
          this.editedProps.expanded = false
        }
      },
      onSearchfilterChanged () {
        if (this.searchFilter.aseguradora) {
          this.pagination.aseguradora = this.searchFilter.aseguradora
        } else {
          this.pagination.aseguradora = null
        }

        if (this.searchFilter.tipo_poliza) {
          this.pagination.tipo_poliza = this.searchFilter.tipo_poliza
        } else {
          this.pagination.tipo_poliza = null
        }

        this.pagination.vigentes = this.searchFilter.vigentes
        this.pagination.start_vi = this.searchFilter.start_vi
        this.pagination.end_vi = this.searchFilter.end_vi
        this.pagination.start_fin = this.searchFilter.start_fin
        this.pagination.end_fin = this.searchFilter.end_fin
        this.pagination.asesor = this.searchFilter.asesor
        this.pagination.search = this.searchFilter.name
        this.pagination.estado = this.searchFilter.estado
        this.pagination.page = 1
      },
      getPolizaUploads () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/polizas/uploads/' + this.editedItem.id)
          .then(res => {
            this.uploads = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      getClientes () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/clientes/search', { params: { search: '' } })
          .then(res => {
            this.clientes = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      getAseguradoras () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/aseguradoras/search', { params: { search: '' } })
          .then(res => {
            this.aseguradoras = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      getTipos () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/tiposPoliza/search', { params: { search: '' } })
          .then(res => {
            this.tipos = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      getAsesores () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/asesores/search', { params: { search: '' } })
          .then(res => {
            this.asesores = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      getRazonesCancelacion () {
        this.$store.dispatch('setDisabledLoading', true)
        this.axios.get('/razonCancelacion/search', { params: { search: '' } })
          .then(res => {
            this.razones = res.data
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.$store.dispatch('setDisabledLoading', false)))
      },
      onFilePicked (event) {
        let files = event.target.files || event.dataTransfer.files
        if (!files.length) {
          return
        }
        let formData = new FormData()
        formData.append('file', files[0])
        formData.append('poliza_id', this.editedItem.id)
        this.editedItem.file_name = files[0].name
        const config = {
          onUploadProgress: progressEvent => {
            this.uploadPercent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          }
        }
        this.uploading = true
        this.uploadPercent = 0
        this.axios.post('/uploads/add', formData, config).then(
          response => {
            this.uploading = false
            this.editedItem.upload_id = response.data.id
            this.getPolizaUploads()
          }
        ).catch(
          error => {
            console.log(error)
            this.uploading = false
            this.errorMessage = 'Unable to Upload File'
            this.error = true
          }
        )
      },
      parseDate (date) {
        let aDate = moment(date, 'DD/MM/YYYY')
        if (aDate.isValid()) {
          return aDate.format('YYYY-MM-DD')
        }
        return moment().format('YYYY-MM-DD')
      },
      parseDateEmpty (date) {
        let aDate = moment(date, 'DD/MM/YYYY')
        if (aDate.isValid()) {
          return aDate.format('YYYY-MM-DD')
        }
        return ''
      }
    },
    validations () {
      let validations = {
        editedItem: {
          cliente: {required},
          aseguradora: {required},
          tipo_poliza: {required},
          nro_poliza: {maxLength: maxLength(20), nroPolizaUnique}
        }
      }
      if (this.editedItem.tipo_poliza && this.editedItem.estado === 'pendiente') {
        validations.editedItem.nro_poliza = {maxLength: maxLength(20), nroPolizaUnique}
      } else {
        validations.editedItem.nro_poliza = {required, maxLength: maxLength(20), nroPolizaUnique}
      }
      if (this.editedItem.tipo_poliza && (this.editedItem.tipo_poliza.nombre === 'Automotor' || this.editedItem.tipo_poliza.nombre === 'Automotor (Flota)')) {
        validations.editedItem.dato_poliza_1 = {maxLength: maxLength(10)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(20)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(20)}
        validations.editedItem.dato_poliza_4 = {required, maxLength: maxLength(4)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Motovehículo') {
        validations.editedItem.dato_poliza_1 = {maxLength: maxLength(10)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(20)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(20)}
        validations.editedItem.dato_poliza_4 = {required, maxLength: maxLength(4)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Casco Embarcaciones') {
        validations.editedItem.dato_poliza_1 = {maxLength: maxLength(10)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(20)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(20)}
        validations.editedItem.dato_poliza_4 = {required, maxLength: maxLength(4)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Hogar') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Integral del Comercio') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Incendio') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Robo de Valores') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(40)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Todo Riesgo Operativo') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(30)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(20)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual en Ocasión del Trabajo') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(100)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Vida Individual') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(10)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(100)}
        validations.editedItem.dato_poliza_3 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Rc Servicios Profesionales (Individual)') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Rc Servicios Médicos (Clínicas)') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Mascotas') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Seguro Técnico') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(200)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Caución') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(200)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Responsabilidad Civil') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(200)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Integro') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(100)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual 24 Horas') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(100)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Deportes') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(100)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Salud - Plan Individual') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(100)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      if (this.editedItem.tipo_poliza && this.editedItem.tipo_poliza.nombre === 'Ap Individual Asistencial') {
        validations.editedItem.dato_poliza_1 = {required, maxLength: maxLength(100)}
        validations.editedItem.dato_poliza_2 = {required, maxLength: maxLength(10)}
      }
      return validations
    },
    watch: {
      pagination: {
        handler () {
          this.getDataFromApi()
        },
        deep: true
      }
    },
    components: {
    },
    mounted () {
      this.getAseguradoras()
      this.getClientes()
      this.getTipos()
      this.getRazonesCancelacion()
      this.getAsesores()
    },
    name: 'PolizaList'
  }
</script>

<style scoped>
    input[type=file] {
        position: absolute;
        left: -99999px;
    }
    .min-btn button {
        margin:0px!important;
        width: auto!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Management/PolizaList.vue